import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Menu } from '@xingternal/menu';
import { ProfileImage } from '@xingternal/profile-image';
import { IconArrowDown, IconArrowUp } from '@xingternal/icons';
import { pathOr } from '@xingternal/malt-util';
import { usePopOver } from '@xingternal/pop-over';
import { BREAKPOINTS } from '@xingternal/util/withMediaListener';
import { SettingsDropdownList } from './SettingsDropdownList';
import { SettingsDropdownButton } from './SettingsDropdown.styles';
import styles from './SettingsDropdown.css';
const dropdownLabelMessage = { id: 'A11Y_SETTINGS_DROPDOWN_LABEL' };
const profileImageTypesMap = {
    MALE: 'female-user',
    FEMALE: 'male-user',
    NONE: 'neutral-user',
};
const SettingsDropdown = ({ matchedMedia, intl, links, user, helpLink }) => {
    const { formatMessage } = intl;
    const label = formatMessage(dropdownLabelMessage);
    const isHandheld = matchedMedia === BREAKPOINTS.handheld;
    const popOver = usePopOver();
    const profileImageUrl = pathOr(undefined, ['profileImage', 0, 'url'], user);
    const profileImageType = pathOr('NONE', ['gender'], user);
    return (React.createElement(Fragment, null,
        React.createElement(SettingsDropdownButton, { "aria-label": label, "data-qa": "SettingsDropdown-button", icon: popOver.show ? IconArrowUp : IconArrowDown, iconAfter: true, size: isHandheld ? 'small' : 'large', innerRef: popOver.triggerRef, onClick: popOver.togglePopOver },
            React.createElement(ProfileImage, { src: profileImageUrl, id: 'personalBarProfilePicture', size: isHandheld ? 'xsmall' : 'small', type: profileImageTypesMap[profileImageType] })),
        React.createElement(Menu, { "data-qa": "SettingsDropdown", isInFlow: true, isStatic: true, dimmerTitle: "close menu", onOutsideClick: popOver.handleHide, show: popOver.show, className: styles.menu, triggerRef: popOver.triggerRef },
            React.createElement(SettingsDropdownList, { links: links, helpLink: helpLink, closeModal: popOver.handleHide }))));
};
SettingsDropdown.propTypes = {
    matchedMedia: PropTypes.string.isRequired,
    intl: PropTypes.object.isRequired,
    links: PropTypes.array.isRequired,
    user: PropTypes.object.isRequired,
    helpLink: PropTypes.string,
};
export { SettingsDropdown };
//# sourceMappingURL=SettingsDropdown.js.map